import React from "react";
import MarkEditor from "../../../_editor/components/rich_plugins/mark_editor/MarkEditor";
import Mark from "../../../common/components/mark/Mark";
import i18n from "i18next";
import { OverlayTrigger, Tooltip, Popover, Overlay } from "react-bootstrap";
import "./../OneClickModal.scss";

/* eslint-disable react/prop-types */
export function OneClick(base) {
  return {
    getRenderTemplate: function (state, props) {
      let marks = props.marks || {};
      let box_id = props.id;
      let mark =
        marks != null
          ? Object.keys(marks)
              .map((key) => marks[key])
              .find((r) => r.origin == box_id)
          : null;
      return (
        <div style={{ height: "100%", width: "100%", zIndex: "1000", cursor: "pointer" }}>
          {mark != null && mark.connectMode == "popup" ? (
            <OverlayTrigger
              key={mark.id}
              text={mark.title}
              placement="auto"
              container={document.getElementById("app")}
              overlay={
                <Popover
                  style={{
                    fontSize: "17px",
                    maxWidth: "60%",
                    maxHeight: "80%",
                    overflowY: "auto",
                    whiteSpace: "break-spaces",
                    backgroundColor: "black",
                    paddingInline: "12px",
                    paddingBlock: "6px",
                    borderRadius: "8px",
                    color: "white",
                  }}
                  id="popover-trigger-click-root-close"
                >
                  {mark.connection}
                </Popover>
              }
              trigger={"click"}
              rootClose
            >
              <div
                id={"oneClickClr" + props.id}
                style={{
                  height: "100%",
                  width: "100%",
                  zIndex: "1000",
                  cursor: "pointer",
                  borderRadius: "15px",
                }}
                onClick={() => {
                  document.getElementById("oneClickClr" + props.id).style.background =
                    "rgb(217 217 217 / 50%)";
                  props.setOneClickEnded(props.id);
                  props.onMarkClicked(props.id, "0");
                }}
              />
            </OverlayTrigger>
          ) : (
            <div
              id={"oneClickColor" + props.id}
              style={{
                height: "100%",
                width: "100%",
                zIndex: "1000",
                cursor: "pointer",
                borderRadius: "15px",
              }}
              onClick={() => {
                document.getElementById("oneClickColor" + props.id).style.background =
                  "rgb(217 217 217 / 50%)";
                props.setOneClickEnded(props.id);
                props.onMarkClicked(props.id, "0");
              }}
            />
          )}
        </div>
      );
    },

    getRichMarkInput: function (state, MarkInput) {
      let div = (
        <div>
          <span>x,y</span>
          <input
            onChange={(event) => {
              MarkInput(event.target.value);
            }}
          />
        </div>
      );
      return div;
    },
    getInitialState: function () {
      return {
        // url: 'http://nemanjakovacevic.net/wp-content/uploads/2013/07/placeholder.png'
        // url:'http://www.amicus.nieruchomosci.pl/grafika/no-image.png'
        // url: 'https://bytesizemoments.com/wp-content/uploads/2014/04/placeholder.png'
        url: img_placeholder, // IdealStudio.Config.image_placeholder,
        allowDeformed: true,
      };
    },
    getDefaultMarkValue(state) {
      return 50 + "," + 50;
    },
    parseRichMarkInput: function (x, y, width, height, toolbarState, boxId) {
      let xx = ((x + 12) * 100) / width;
      let yy = ((y + 26) * 100) / height;
      let finalValue = yy.toFixed(2) + "," + xx.toFixed(2);

      return finalValue;
    },
    validateValueInput: function (value) {
      let regex = /(^-*\d+(?:\.\d*)?),(-*\d+(?:\.\d*)?$)/g;
      let match = regex.exec(value);
      if (match && match.length === 3) {
        let x = Math.round(parseFloat(match[1]) * 100) / 100;
        let y = Math.round(parseFloat(match[2]) * 100) / 100;
        if (isNaN(x) || isNaN(y) /* || x > 100 || y > 100 || x < -100 || y < -100*/) {
          return { isWrong: true, message: i18n.t("HotspotImages.message_mark_xy") };
        }
        value = x + "," + y;
      } else {
        return { isWrong: true, message: i18n.t("HotspotImages.message_mark_xy") };
      }
      return { isWrong: false, value: value };
    },
  };
}
/* eslint-enable react/prop-types */
